import useFeatureFlag from "../../../../../graphql/hooks/useFeatureFlag";
import useCurrentUser from "../../../../../hooks/useCurrentUser";

export const useAsk2Enabled = (): boolean => {
  const currentUser = useCurrentUser();
  const orgSettingEnabled = currentUser?.organization?.askEnabled ?? false;
  const flagEnabled = useFeatureFlag("interview_ask:v2");
  return orgSettingEnabled && flagEnabled;
};
